import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from '@spartacus/core';
import moment from 'moment';
import { retry } from 'rxjs/operators';


// const I18N_VALUES = {
//   'en':{
//     weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thru', 'Fri', 'Sat'],
//     months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug','Sep','Oct','Nov','Dec'],
//     weekLabel: 'sem'
//   },
//   'fr': {
//     weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
//     months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
//     weekLabel: 'sem'
//   },
//   "zh": {
//     weekdays: [],
//     months: [],
//     weekLabel: ''
//   }
//   // other languages you would support
// };


/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
 @Injectable()
 export class CustomAdapter extends NgbDateAdapter<string> {
 
   readonly DELIMITER = '-';
 
   fromModel(value: string | null): NgbDateStruct | null {
     if (value) {
       const date = value.split(this.DELIMITER);
       return {
         day : parseInt(date[0], 10),
         month : parseInt(date[1], 10),
         year : parseInt(date[2], 10)
       };
     }
     return null;
   }
 
   toModel(date: NgbDateStruct | null): string | null {
     return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : null;
   }
 }

 @Injectable()
 export class CustomAdapterRecordPickup extends NgbDateAdapter<string> {
 
   readonly DELIMITER = '-';
 
   fromModel(value: string | null): NgbDateStruct | null {
     if (value) {
       const date = value.split(this.DELIMITER);
       return {
         day : parseInt(date[0], 10),
         month : parseInt(date[1], 10),
         year : parseInt(date[2], 10)
       };
     }
     return null;
   }
 
   toModel(date: NgbDateStruct | null): string | null {
     return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
   }
 }


/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
 @Injectable()
 export class CustomDateParserFormatter extends NgbDateParserFormatter {
 
   readonly DELIMITER = '/';
 
   parse(value: string): NgbDateStruct | null {
     if (value) {
       const date = value.split(this.DELIMITER);
       return {
         day : parseInt(date[0], 10),
         month : parseInt(date[1], 10),
         year : parseInt(date[2], 10)
       };
     }
     return null;
   }
   checkPad(d){
    return (d < 10) ? '0' + d.toString() : d.toString();
  }
   format(date: NgbDateStruct | null): string {
    let formatDate = date ? this.checkPad(date?.day) + this.DELIMITER + this.checkPad(date?.month) + this.DELIMITER + date.year : '';
    return formatDate
    }
 }

@Injectable({
  providedIn: 'root'
})
export class DateRangePickerI18nService extends NgbDatepickerI18n{
  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    return '';
  }
  getWeekdayShortName(weekday: number): string {
    let result='Sun,Mon,Tue,Wed,Thur,Fri,Sat';
    this.translation.translate('home.I18N_VALUES.weekdays').subscribe(res=>{
      result = res;
    })
    return result.split(',')[weekday - 1];
    //return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number, year?: number): string {
    let result='Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec';
    this.translation.translate('home.I18N_VALUES.months').subscribe(res=>{
      result = res;
    })
    return result.split(',')[month - 1]
    //return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number, year?: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  constructor(private translation: TranslationService) {
    super();
  }
}
